/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../index.js';

export default cjs;

export const {
  ACTOR_KINDS,
  ACTOR_KIND_ID_TYPES,
  ACTOR_KIND_VALUES,
  ANY_TENANT_ID_PATTERN,
  DESIGNATED_TEST_COMPANY_ID,
  DESIGNATED_TEST_TENANT_ID,
  DISPOSABLE_SCHEMA_PATTERN,
  ENTITY_TYPE_BY_PREFIX,
  EPHEMERAL_ID_TYPES,
  ID_PREFIXES,
  LEAKED_PARTITION_PATTERN,
  MAX_SLUG_LEN,
  NON_COMPANY_TENANT_SCHEMAS,
  NON_ROW_ID_KINDS,
  PREFIXED_ID_PATTERN,
  RETIRED_ENTITY_PATTERNS,
  SYSTEM_ACTORS,
  TENANT_ID_COLUMNS,
  TENANT_ID_PATTERN,
  TENANT_ID_SEMANTICS,
  TENANT_PREFIX,
  TENANT_SCHEMA_IDENTIFIER_PATTERN,
  TENANT_SURFACE_CLASSES,
  TENANT_TEMPLATE_SCHEMA,
  TEST_ISOLATION_KEY_PATTERN,
  TEST_TENANT_ID_PATTERN,
  assertEntityId,
  assertNotTenantTemplateSchema,
  auditSubjectOf,
  buildIdPattern,
  buildLaborBudgetSlug,
  buildLocationSlug,
  buildPlanName,
  buildPlanSlug,
  buildScheduleDraftSlug,
  buildShiftTemplateSlug,
  buildTenantPattern,
  deterministicId,
  disambiguate,
  disposableSchemaPatternSource,
  entityTypeForPrefix,
  entityTypeOf,
  generateId,
  getIdPrefixPattern,
  getPrefixPattern,
  isNonCompanyTenantSchema,
  isNonRowIdSchema,
  isSystemActor,
  isTenantTemplateSchema,
  isValidPrefixedId,
  joiNonRowId,
  joiPrefixedId,
  kindOfSentinel,
  ownTenantColumnMismatches,
  provenCustomerActor,
  provenOwnerActor,
  provenStaffActor,
  provenUserActor,
  slugify,
  tenantIdPatternFor,
  unprovenStaffActor,
  unprovenUserActor,
} = cjs;
